import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../auth';
import { useUnits } from '../units';
import { SiteFooter } from './SiteFooter';
import { UnitSwitcher } from './UnitSwitcher';

export function AppShell() {
  const { me, logout } = useAuth();
  const { currentUnit, hasRole, councilCanView, councilCanMessage } = useUnits();

  const canAdminUnit = hasRole('ADMIN');
  const canRoster = hasRole('ADMIN') || hasRole('DEN_LEADER');
  const canMessage = canRoster || councilCanMessage;

  return (
    <div className="app">
      <header className="topbar">
        <div className="topbar-left">
          <span className="brand">DenLodge</span>
          <UnitSwitcher />
        </div>
        <nav className="topbar-nav">
          <NavLink to="/" end>
            Overview
          </NavLink>
          {currentUnit && (canRoster || councilCanView('roster')) && (
            <NavLink to={`/units/${currentUnit.id}/roster`}>Roster</NavLink>
          )}
          {currentUnit && canRoster && (
            <NavLink to={`/units/${currentUnit.id}/dens`}>Dens</NavLink>
          )}
          {currentUnit && (canRoster || councilCanView('meetings')) && (
            <NavLink to={`/units/${currentUnit.id}/meetings`}>Meetings</NavLink>
          )}
          {currentUnit && canRoster && (
            <NavLink to={`/units/${currentUnit.id}/catalog`}>Catalog</NavLink>
          )}
          {currentUnit && <NavLink to={`/units/${currentUnit.id}/calendar`}>Calendar</NavLink>}
          {currentUnit && (
            <NavLink to={`/units/${currentUnit.id}/announcements`}>Announcements</NavLink>
          )}
          {currentUnit && canMessage && (
            <NavLink to={`/units/${currentUnit.id}/messaging`}>Messaging</NavLink>
          )}
          {currentUnit &&
            (hasRole('ADMIN') || hasRole('PACK_COMMITTEE_FINANCE') || councilCanView('finance')) && (
              <NavLink to={`/units/${currentUnit.id}/finance`}>Finance</NavLink>
            )}
          {currentUnit && hasRole('PARENT') && (
            <NavLink to={`/units/${currentUnit.id}/family`}>My Scout</NavLink>
          )}
          {currentUnit && canAdminUnit && (
            <NavLink to={`/units/${currentUnit.id}/members`}>Members</NavLink>
          )}
          {currentUnit && canAdminUnit && (
            <NavLink to={`/units/${currentUnit.id}/website`}>Website</NavLink>
          )}
          {me?.isPlatformAdmin && <NavLink to="/admin/units">All units</NavLink>}
          {me?.isPlatformAdmin && <NavLink to="/admin/settings">Platform settings</NavLink>}
        </nav>
        <div className="topbar-right">
          <span className="muted small">{me?.user.email}</span>
          <button onClick={logout}>Sign out</button>
        </div>
      </header>
      <main className="content">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
